module.exports = __webpack_public_path__ + "static/media/CS111.9b7a5038.PNG";